import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface Props {
  to: string;
  children: ReactNode;
}

const Item = ({ to, children }: Props) => {
  const { pathname } = useLocation();
  const isActive = pathname === to;

  return (
    <motion.li
      whileHover={{ x: 6 }}
      whileTap={{ scale: 0.98 }}
      className="w-full list-none"
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
    >
      <Link
        to={to}
        className={`
          relative block w-full py-4 px-6 rounded-xl transition-all duration-300 overflow-hidden
          ${
            isActive
              ? "bg-gradient-to-r from-green-800/60 to-emerald-800/60 text-yellow-400 font-semibold border-l-4 border-yellow-500"
              : "text-gray-200 hover:bg-white/10 hover:text-yellow-400 border-l-4 border-transparent"
          }
        `}
      >
        {/* Glow effect on active */}
        {isActive && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="absolute inset-0 bg-gradient-to-r from-yellow-500/10 to-transparent pointer-events-none"
          />
        )}
        
        <span className="relative z-10">{children}</span>
      </Link>
    </motion.li>
  );
};

export default Item;